<template>
  <div class="admin-users">

    <div class="pad">
      <b-message type="is-danger" v-if="errMsg.length">{{ errMsg }}</b-message>
    </div>

    <div class="pad-left pad-right flex">
      <b-field label="" :custom-class="sizeClass">
        <b-input type="search" placeholder="Search" v-model="filterStr" :size="sizeClass" />
      </b-field>
      <div class="flex-1"></div>
      <button style="margin-left: 50px;" class="button is-success is-small" @click="$router.push('/admin-users/add')">Add Admin User</button>
    </div>

    <div class="flex-table">
      <div class="flex-table-header flex">
        <div class="flex-cell flex-1">ID</div>
        <div class="flex-cell flex-3">Name</div>
        <div class="flex-cell flex-2">Username</div>
        <div class="flex-cell flex-1"></div>
      </div>
      <div class="flex-table-body">
        <div class="flex-table-row flex" v-for="u in filteredUsers" :key="u.id">
          <div class="flex-cell flex-1">{{ u.id }}</div>
          <div class="flex-cell flex-3">{{ u.name }}</div>
          <div class="flex-cell flex-2">{{ u.username }}</div>
          <div class="flex-cell flex-1 flex-middle">
            <button class="button is-small is-fullwidth" @click="$router.push(`/admin-users/edit/${u.id}`)">
              <font-awesome-icon icon="edit" />edit
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      users: [],
      filterStr: '',
      errMsg: '',
      errMsgTimer: null,
      sizeClass: 'is-small'
    }
  },
  computed: {
    filteredUsers () {
      let str = this.filterStr.toLowerCase().trim()
      return this.users
        .filter(user => {
          return user.name.toLowerCase().indexOf(str) >= 0 || user.username.toLowerCase().indexOf(str) >= 0
        })
    }
  },
  watch: {
    errMsg () {
      clearTimeout(this.errMsgTimer)
      if (this.errMsg.length) {
        this.errMsgTimer = setTimeout(() => { this.errMsg = '' }, 3000)
      }
    }
  },
  created () {
    this.$api('getAdminUsers')
      .then(resp => { this.users = resp.data })
      .catch(err => { this.errMsg = err.toString() })
  }
}
</script>

<style>

</style>
